type AppState = 'home' | 'search';

export interface AppStateWindow extends Window {
  appState?: AppState;
  appSearchQuery?: string | undefined;
}

export const getExternalAppState = () => {
  return (window as AppStateWindow).appState;
};

export const setExternalAppState = (
  state: AppState,
  {query, tab, geo}: {query?: string; tab?: string; geo?: string} = {}
) => {
  (window as AppStateWindow).appState = state;
  (window as AppStateWindow).appSearchQuery = query;

  window.postMessage(
    {
      data: {
        geo,
        query,
        state,
        tab
      },
      scope: 'appstate'
    },
    window.location.href
  );
};

export const publishExternalEvent = (eventName: string) => {
  window.postMessage(
    {
      data: {
        eventName
      },
      scope: 'userAction'
    },
    window.location.href
  );
};
